import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { PolicyStates } from "@shared/enums/policy-states";
import { BankInformationPolicyVm } from "@shared/models/policy-details";
import { Guid } from "guid-typescript";

@Component({
  selector: "app-detail-info-card-pj",
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: "./detail-info-card-pj.component.html",
})
export class DetailInfoCardPjComponent {
  @Input() validityDate!: Date | string;
  @Input() monthlyPremiumTTC!: number | string;
  @Input() promotionCode!: string | null;
  @Input() untilTextKey!: string;
  @Input() amountTextKey!: string;
  @Input() promoTextKey!: string;
  @Input() effectiveStartDate?: Date;
  @Input() policyStatus?: PolicyStates;
  @Input() isReceiptPage = false;
  @Input() policyId!: Guid;
  @Input() paymentInformations!: BankInformationPolicyVm;
  @Input() terminationDate?: Date;
}
